import { Fragment, useCallback, useEffect } from "react";
import { OptionItem } from "./OptionItem";

import styles from "../../../styles/service/product-details.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

const getTextMinMaxOptions = (question) => {
  const min = question?.min;
  const max = question?.max;

  if (min === 0 && max >= 1) return `Selecione até ${max}`;

  if (min === max) return `Selecione ${max}`;

  if (min >= 1 && !max) return `Selecione pelo menos ${min}`;

  if (min >= 1 && min < max) return `Selecione de ${min} a ${max}`;
};

const checkIsDisabledOption = (question, option) => {
  const max = question?.max;

  const selectedOptions = question.items.reduce(
    (t, o) => (o.selected ? t + o.quantity : t),
    0,
  );
  if (max && max <= selectedOptions) return true;
};

const formatInputExtra = (question) => {
  switch (true) {
    case question.min === 1 && question.max === 1:
      return true;
    default:
      return false;
  }
};

export const QuestionItem = ({
  question,
  onChange,
  highlightError,
  onCompletedQuestion,
}) => {
  const min = question?.min;
  const selectedOptions = question.items.reduce(
    (t, o) => (o.selected ? t + o.quantity : t),
    0,
  );

  const handleCompletedQuestion = useCallback(() => {
    const selected = question.items.reduce(
      (t, o) => (o.selected ? t + o.quantity : t),
      0,
    );

    if (min === 0) return onCompletedQuestion?.(question.ref_id);

    if (selected < min) {
      onCompletedQuestion?.(question.ref_id, true);
    } else if (selected >= min) {
      onCompletedQuestion?.(question.ref_id);
    }
  }, [min, onCompletedQuestion, question]);

  const handleOptionClick = (option, optionIndex) => {
    if (question.mode === "quantity") {
      const currentTotal = question.items.reduce(
        (t, o) => (o.selected ? t + o.quantity : t),
        0,
      );
      if (question.max && currentTotal >= question.max) return;
      const newQuantity = (option.quantity || 0) + 1;
      question.items[optionIndex] = {
        ...option,
        quantity: newQuantity,
        selected: true,
      };
    } else if (question.max === 1 && question.min === 1) {
      question.items.forEach((o) => (o.selected = false));
      question.items[optionIndex] = {
        ...option,
        selected: !option.selected,
        quantity: +(!option.selected),
      };
    } else {
      const isSelecting = !option.selected;
      if (isSelecting) {
        const currentTotal = question.items.reduce(
          (t, o) => (o.selected ? t + o.quantity : t),
          0,
        );
        if (question.max && currentTotal >= question.max) return;
      }
      question.items[optionIndex] = {
        ...option,
        selected: isSelecting,
        quantity: +isSelecting,
      };
    }

    handleCompletedQuestion();
    onChange(question);
  };

  const handleOptionLongPress = (option, optionIndex) => {
    const newQuantity = Math.max(0, (option.quantity || 1) - 1);
    question.items[optionIndex] = {
      ...option,
      quantity: newQuantity,
      selected: newQuantity > 0,
    };
    handleCompletedQuestion();
    onChange(question);
  };

  useEffect(() => {
    handleCompletedQuestion();
  }, [question]);

  return (
    <>
      <div
        className={css({
          sectionHeader: true,
        })}
      >
        <p className={styles.title}>{question.name}</p>
        {(question?.min > 0 || question?.max > 0) && (
          <span
            className={css({
              selectQuantity: true,
            })}
          >
            {getTextMinMaxOptions(question)} ({selectedOptions}/{question.max})
          </span>
        )}
        
      </div>

      <div className={css({ options: true })}>
        {(question.items || []).map((option, optionIndex) => (
          <Fragment key={optionIndex}>
            <OptionItem
              option={option}
              singleOption={formatInputExtra(question)}
              sameOptions={question.mode === "quantity"}
              onClick={(newOption) => handleOptionClick(newOption, optionIndex)}
              onLongPress={(newOption) =>
                handleOptionLongPress(newOption, optionIndex)
              }
              disabled={checkIsDisabledOption(question, option)}
            />
          </Fragment>
        ))}
      </div>
    </>
  );
};
